import { getTranslation } from "utils/translation";
import { Dialog } from "components/dialog/Dialog";
import { DialogFooter } from "components/dialog/DialogFooter/DialogFooter";
import { DialogHeader } from "components/dialog/DialogHeader/DialogHeader";
import { DialogBody } from "components/dialog/DialogMain/DialogBody/DialogBody";
import { DialogMain } from "components/dialog/DialogMain/DialogMain";
import { useDialogContext } from "components/dialog/controller/DialogProvider";

export const SwitchPagesDialog = () => {
  const { dialogProps } = useDialogContext();
  return (
    <Dialog size="small" state="info">
      <DialogHeader>{getTranslation("resource", "SWITCH_PAGES")}</DialogHeader>
      <DialogMain>
        <DialogBody>
          {getTranslation("message", "CONFIRM.SWITCH_PAGE")}
        </DialogBody>
      </DialogMain>
      <DialogFooter
        button={{
          label: getTranslation("resource", "SWITCH"),
          onClick: dialogProps.buttonClick,
        }}
      />
    </Dialog>
  );
};
